<template>
  <section class="display-section display-section__brand">
    <div class="display-header">
        <h2 class="visually-hidden">요즘 관심받는 브랜드 모바일 쿠폰(기프티콘, 상품권)</h2>
        <div class="display-title">
            <p>예스콘 피셜</p>
            <p><strong>요즘 관심 받는 브랜드</strong></p>
        </div>
        <button class="plus-themore" @click="goToMoreViewProductList()">+더보기</button>
    </div>
    <div class="display-body position-relative">
        <div class="brand-product-tap">
            <!-- 브랜드 리스트 탭 -->
            <ul class="brand-select-list">
                <li v-for="(item, index) in interestedBrandList" v-bind:key="index">
                    <div class="form-check-stick2">
                        <input type="radio" :id="`interestedbrand${item.brdId}`" :value="item" v-model="seletedRadioBrand" class="visually-hidden">
                        <label :for="`interestedbrand${item.brdId}`" class="form-check-stick2-label">
                            <figure class="brand-thumb" :style="`background-image: url(${item.brdImgPath});`"></figure>
                            <span class="text-overflow-1">{{item.brdNm}}</span>
                        </label>
                    </div>
                </li>
            </ul>
            <!-- 상품 리스트 -->
            <div class="product-list">
                <div class="item-list-row">
                    <div class="item-list-alignment" v-for="(item, rowNum) in vuexInterestedBrandGoodsList" :key="rowNum">
                        <div class="product-item" :class="{'sale': (item.goodsPriceMarket - item.goodsPricePoc) > 0, 'secret': item.secretGoodsYn === 'Y'}">
                            <div>
                                <div :id="`brandProductThumb${rowNum}`" class="position-relative">
                                    <router-link v-bind:to="`/details/${item.goodsId}`">
                                        <figure>           
                                            <template v-if="item.secretGoodsYn === 'Y'">
                                            <img loading="lazy" decoding="async" class="position-absolute i-secret" src="@/assets/img/icon_secret.svg" alt="시크릿가 상품">
                                            </template>
                                            
                                            <img loading="lazy" decoding="async" class="product-img" :src="`${item.goodsImgPath}`" :alt="`${item.goodsNm}`">
                                        </figure>
                                    </router-link>
                                </div>
                                <div class="product-info">
                                    <div class="product-name">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="brand" aria-label="브랜드명">{{ item.brdNm }}</div>
                                            <div class="util-btns">
                                                <template v-if="item.withGoodsYn === 'N'">
                                                    <button type="button" :id="`addToMyWishByBrandtBtn${rowNum}`" class="btn-wish btn-wish--add" :ga-attr-btn-add-to-my-wish="item.goodsNm" 
                                                        @click="changeWish($event, `${item.catId}`,`${item.eventId}`,`${item.goodsId}`,`${rowNum}`)">관심상품 추가</button>
                                                </template>
                                                <template v-else-if="item.withGoodsYn === 'Y'">
                                                    <button type="button" :id="`removeFromMyWishByBrandBtn${rowNum}`" class="btn-wish btn-wish--remove" aria-lable="" :ga-attr-btn-remove-from-my-wish="item.goodsNm"
                                                            @click="changeWish($event, `${item.catId}`,`${item.eventId}`,`${item.goodsId}`,`${rowNum}`)">관심상품 취소</button>
                                                </template>

                                                <template v-if="item.secretGoodsYn != 'Y'">
                                                    <button type="button" :id="`addToEstimateByBrandBtn${rowNum}`" class="btn-estimate btn-estimate--add" :ga-attr-btn-add-to-estimate="item.goodsNm" 
                                                        @click="addEstimate(item.goodsId)">견적서 추가</button>
                                                </template>
                                            </div>
                                        </div>
                                        <router-link v-bind:to="`/details/${item.goodsId}`">
                                            <h3 class="title" aria-label="상품명">{{ item.goodsNm }}</h3>
                                        </router-link>
                                    </div>
                                    <div class="product-cost">
                                        <template v-if="(item.goodsPriceMarket - item.goodsPricePoc) > 0">
                                            <!-- <div class="discount-rate" aria-label="할인율">{{Math.round((item.goodsPriceMarket - item.goodsPricePoc)/item.goodsPriceMarket*100)}}%</div> -->
                                            <template v-if="item.discountRatio !== '0'">
                                                <div class="discount-rate" aria-label="할인율">
                                                        {{item.discountRatio}}%
                                                </div>
                                            </template>
                                        </template>

                                        <!-- 할인가 or 시크릿가 -->
                                        <ins class="discount-price" aria-label="가격">{{Number(item.goodsPricePoc).toLocaleString()}}원</ins>
                                        
                                        <template v-if="(item.goodsPriceMarket - item.goodsPricePoc) > 0">
                                            <del class="origin-price" aria-label="정상가">{{Number(item.goodsPriceMarket).toLocaleString()}}원</del>
                                        </template>
                                    </div>
                                    <template v-if="item.secretGoodsYn === 'Y' && item.limitCnt !== 0">
                                    <div class="secret-expiration">
                                        <template v-if="item.validEndDate">
                                        <p class="expiration-date">~ {{item.validEndDate}}까지 주문가능</p>
                                        </template>
                                        <p class="expiration-amount">주문 가능 수량 {{item.limitCnt}}개 남음</p>
                                    </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 토스트메시지 -->        
                <ToastMessage></ToastMessage>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { showToastMessage } from '@/util';
export default {
    components: {
        ToastMessage: () => import('@/components/tiny-element/ToastMessage.vue'),       // 토스트메시지
    },
    data(){
        return{
            toggleShow: false,                  // 카테고리 리스트 토글 오픈 여부
            seletedRadioBrand: null,            // 선택한 브랜드
            order:'POPULAR',                    // 정렬 기준
            keywords:[],                        // 더보기 클릭 시 해당 키워드
            interestedBrandList: JSON.parse(process.env.VUE_APP_BRAND_PRODUCT)
        }
    },

    computed: {
        ...mapState({
            userNo: state => state.userNo,
            authentication: state => state.authentication,
            categoryDatas: state => state.exploreProductStore.vuexCategoryAllList,
            brandDatas: state => state.exploreProductStore.vuexBrandAllList,
            vuexInterestedBrandGoodsList: state => state.mainStore.vuexInterestedBrandGoodsList
        }),
    },

    mounted(){
        this.seletedRadioBrand = this.interestedBrandList[0];
    },

    watch: {
        seletedRadioBrand(){
            // 메인페이지에서 해당 브랜드 클릭 시 상품 조회
            if(this.seletedRadioBrand.brdId) {
                this.dispatchInterestedBrandGoodsList();
                this.$store.commit('mainStore/setVuexMainBottomCheckedBrand', this.seletedRadioBrand);
            }
        },
    },

    methods: {
        dispatchGoodsList() {
            this.dispatchDiscountRatioGoodsList();
            this.dispatchPopularProductList();
            this.dispatchFinalYearBestGoodsList();
        },

        // 메인 관심받는 브랜드 상품 조회
        async dispatchInterestedBrandGoodsList(){
            try {
                let params = {
                    order:'POPULAR' ,
                    pageNum : 1 ,
                    pageSize : 4 ,
                    brdIdList: this.seletedRadioBrand.brdId,
                    userNo: this.userNo
                }

                const response = await this.$store.dispatch('goodsStore/actionsFindAllGoodsList', params);
                this.$store.commit('mainStore/setVuexInterestedBrandGoodsList', response.data.list);
            } catch(err) {
                return;
            }
        },

        goToMoreViewProductList() {
            this.keywords = this.seletedRadioBrand.brdNm;
            this.$router.push({name:"search", query: {data: this.keywords}}).catch(()=>{});
        } ,

        // 견적서 추가
        addEstimate(goodsId){
			// 견적서 쿠키데이터 존재?
			const isValidAlreadyCookiesGoodsid = this.validAlreadCookiesGoodsId(goodsId);

			if(isValidAlreadyCookiesGoodsid) {
				showToastMessage('상품이 견적서에 추가되었습니다.', '/estimate');
			} else {
				showToastMessage('이미 견적서에 추가되었습니다.', '/estimate');
			}
        },

		validAlreadCookiesGoodsId(goodsId) {
			const isCookiesEstimate = this.$cookies.isKey('estimateObj');
			let isValidAlreadyCookiesGoodsid = false;

			if(isCookiesEstimate) {
				const cookiesEstimateObj = this.$cookies.get('estimateObj');
				const isAlreadyGoodsId = cookiesEstimateObj.goodsIdList.includes(goodsId);

				if(isAlreadyGoodsId) {
					return isValidAlreadyCookiesGoodsid;
				} else {
					this.setCookiesEstimateObj(goodsId, cookiesEstimateObj);
					isValidAlreadyCookiesGoodsid = true;
				}
				
			} else {
				this.setCookiesEstimateObj(goodsId, null);
				isValidAlreadyCookiesGoodsid = true;
			}

			return isValidAlreadyCookiesGoodsid;
		},

		setCookiesEstimateObj(goodsId, cookiesEstimateObj) {
			let tempEstimateObj = {...this.estimateObj};
			tempEstimateObj.goodsIdList = [];
			tempEstimateObj.goodsIdList.push(goodsId);

			if(cookiesEstimateObj) {
				const cookiesGoodsList = cookiesEstimateObj.goodsIdList;
				cookiesGoodsList.forEach((value) => {
					tempEstimateObj.goodsIdList.push(value);
				}) 
			}
			
			this.$cookies.set('estimateObj', tempEstimateObj);
		},

        // 관심상품 추가/제거
		changeWish(event, catId, eventId, goodsId, rowNum) {
            // 비로그인일 경우
			if (!this.userNo) {
				if (confirm("로그인이 필요합니다.") == true) {    // 확인
					this.$router.push("/login")
				} else {   // 취소
					return;
				}
			} else {
				const id = event.currentTarget.id;
				if (id.includes('removeFromMyWishByBrandBtn')) {
					//관심상품 테이블에 데이터 삭제
					this.dispatchDeleteWishGoods(catId, eventId, goodsId, rowNum)
				} else {
					//관심상품 테이블에 데이터 추가
					this.dispatchRegistWishGoods(catId, eventId, goodsId, rowNum);
				}
			}		
		},

        async dispatchRegistWishGoods(catId, eventId, goodsId, rowNum) {
            try {
                const data = {
                    catId: catId , 
                    eventId: eventId , 
                    goodsId: goodsId ,
                    userNo: this.userNo
                }

                await this.$store.dispatch('wishGoodsStore/actionsRegistWishGoodsApi', data);
                this.vuexInterestedBrandGoodsList[rowNum].withGoodsYn = 'Y';
                this.dispatchGoodsList();
                // 토스트메시지 알람, 바로가기 링크
                showToastMessage('관심상품이 추가되었습니다.', '/myproduct');
            } catch(err) {
                alert(err.response.data.message);
                return;
            }
        },

        async dispatchDeleteWishGoods(catId, eventId, goodsId, rowNum) {
            try {
                const data = {
                    catId: catId , 
                    eventId: eventId , 
                    goodsId: goodsId ,
                    userNo: this.userNo
                }

                await this.$store.dispatch('wishGoodsStore/actionsDeleteWishGoodsApi', data);
                this.vuexInterestedBrandGoodsList[rowNum].withGoodsYn = 'N';
                this.dispatchGoodsList();
                // 토스트메시지 알람
                showToastMessage('관심상품에서 제거되었습니다.', '/myproduct');
            } catch(err) {
                alert(err.response.data.message);
                return;
            }
        },

        async dispatchDiscountRatioGoodsList() {
            try {
                let params = {
                    order:'DISCOUNT_RATIO' ,
                    pageNum : 1 ,
                    pageSize : 4 ,
                    userNo : this.userNo
                }
                const response = await this.$store.dispatch('goodsStore/actionsFindAllDiscountRatioGoodsList', params);
                this.$store.commit('mainStore/setVuexDiscountRatioGoodsList', response.data.list);
            } catch(err) {
                return;
            }
        },

        async dispatchPopularProductList() {
            try {
                let params = {
                    order:'POPULAR' ,
                    pageNum : 1 ,
                    pageSize : 4 ,
                    userNo : this.userNo
                }
                const response = await this.$store.dispatch('goodsStore/actionsFindAllPopularGoodsList', params);
                this.$store.commit('mainStore/setVuexPopularGoodsList', response.data.list);
            } catch(err) {
                return;
            }
        
        },

        // 연말 BEST 상품 메인 리스트 조회
        async dispatchFinalYearBestGoodsList() {
            try {
                let params = {
                    order:'POPULAR' ,
                    pageNum : 1 ,
                    pageSize : 4 ,
                    keywords : '연말베스트선물',
                    userNo : this.userNo
                }
                const response = await this.$store.dispatch('goodsStore/actionsFindAllGoodsList', params);
                this.$store.commit('mainStore/setVuexMainFinalYearBestGoodsList', response.data.list);
            } catch(err) {
                return;
            } 
        },
    }
}
</script>

<style lang="scss" scoped>

@import '@/assets/css/product.scss';

    .brand-product-tap{
        display: flex;
        justify-content: space-between;
        gap: 28px;
        flex-direction: column;

        @media (min-width: 1200px) {
            flex-direction: row;
        }
        .product-list{
            flex: 1;
        }
    }
        .category-select-list{
            z-index: 2;
            background: var(--white);
            box-shadow: var(--box-shadow);
            min-width: 165px;
            line-height: 1;
            color: var(--black);
            font-weight: 600;
            font-size: 16px;
            padding: 20px 0;

            li {
                padding: 12px 16px;
                cursor: pointer;
            }

            @media (min-width: 1200px) {
                min-width: 260px;
                font-size: 24px;
            }
        }

        .brand-select-list{
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 4px;

            @media (min-width: 768px) {
                grid-template-columns: repeat(3, 1fr);
            }

            @media (min-width: 1200px) {
                display: flex;
                flex-direction: column;
            }

            .form-check-stick2-label{
                display: flex;
                align-items: center;
                gap: 8px;
                border-radius: var(--border-radius);
                border: solid 1px var(--gray-20);
                background-color: var(--white);
                height: 36px;
                padding: 0 12px;
                font-size: 14px;
                font-weight: 500;

                @media (min-width: 1200px) {
                    gap: 20px;
                    width: 282px;
                    height: 64px;
                    font-size: 16px;
                }

                .brand-thumb{
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    overflow: hidden;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: 100%;
                    background-color: var(--white); // --gray-10

                    img{
                        width: 100%;
                    }

                    @media (min-width: 1200px) {
                        width: 44px;
                        height: 44px;
                    }
                }
            }

            input {
                &:checked+label.form-check-stick2-label,
                &[checked="checked"]+label.form-check-stick2-label {
                    background-color: var(--gray-20);
                }
            }
        }

        .item-list-row{
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;

            @media (min-width: 576px) { /* col-xs */
                grid-template-columns: repeat(4, 1fr);
            }

            @media (min-width: 768px) { /* col-sm */
                grid-template-columns: repeat(4, 1fr);
            }

            @media (min-width: 1200px) {
                grid-template-columns: repeat(3, 1fr);
            }
        }

        .item-list-alignment:nth-child(4){        
            @media (min-width: 1200px) {
                display: none;
            }
        }
</style>